import { useQuery } from '@tanstack/react-query';

import { $apiV2 } from 'modules/global';

import { IResult } from '../models';
import { lessonConst } from '..';

export const useLessonResult = (slug?: string) => {
  const { data, ...args } = useQuery<{ results: IResult }>({
    queryKey: [lessonConst.queryKeys.LESSONS_RESULT, slug],
    queryFn: async () => {
      const { data } = await $apiV2.get(`/teacher-course/lessons/${slug}/result`);

      return { results: data?.data };
    }
  });

  return { ...data, ...args };
};
